import { ReactComponent as Previous } from "assets/svg/outline-chevron-left-16.svg";
import { ReactComponent as Next } from "assets/svg/outline-chevron-right-16.svg";
import IconButton from "components/icon-button";
import LazyImage from "components/lazy-image";
import { Button, Col, Row } from "react-bootstrap";

import getClasses from "utils/getClasses";
import styles from "./PatientBookCalendar.module.scss";
import {
  APPOINTMENT_TYPES_SELECT_EMPTY_OPTION,
  AppointmentTypesSelectOption,
} from "../appointment-types-select/AppointmentTypesSelect";

const EMPTY_STATE = "/img/dashboard/upcoming-session-empty-state.png";

export interface PatientBookCalendarEmptyStateProps {
  showThreeRows?: boolean;
  trackClick: (elementName: string) => void;
  changeWeek: (offset: any) => Promise<void>;
  openRequestDifferentTimeModal?: () => void;
  selectedType: AppointmentTypesSelectOption | undefined;
}

const PatientBookCalendarEmptyState = ({
  showThreeRows,
  trackClick,
  changeWeek,
  openRequestDifferentTimeModal,
  selectedType,
}: PatientBookCalendarEmptyStateProps) => {
  if (
    !selectedType ||
    selectedType.label === APPOINTMENT_TYPES_SELECT_EMPTY_OPTION.label
  ) {
    return (
      <div
        className={getClasses(
          styles["empty-state--dr-block"],
          showThreeRows && styles["empty-state--dr-block-full-profile"],
        )}
      >
        <LazyImage src={EMPTY_STATE} width={110} height={110} />
        <div className="mx-auto rg-14 gray01 mt-3">
          Select a session type to view availability.
        </div>
      </div>
    );
  }

  return (
    <>
      <p className="md-14 gray02 mb-2">Select an available time</p>
      <Row className="align-items-center">
        <Col className={`p-0 ${styles["col-left"]}`}>
          <IconButton
            onClick={() => {
              trackClick("previous-days-button");
              changeWeek(-1);
            }}
          >
            <Previous />
          </IconButton>
        </Col>
        <div className="mx-auto rg-14 gray01">No available sessions</div>
        <Col className={`p-0 ${styles["col-right"]}`}>
          <IconButton disabled>
            <Next />
          </IconButton>
        </Col>
      </Row>
      <div className={styles["request-appointment"]}>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => {
            trackClick("request-different-time-button");

            openRequestDifferentTimeModal && openRequestDifferentTimeModal();
          }}
        >
          Request appointment
        </Button>
      </div>
    </>
  );
};

export default PatientBookCalendarEmptyState;
